import { useState, useContext } from 'react'
import axios from 'axios'
import AlertContext from '../../../Product/context/alert/alertContext'
import AuthContext from '../../../Product/context/auth/authContext'

export const useAuctionTerms = ({ onAccepted }) => {
    const { user } = useContext(AuthContext)
    const alertContext = useContext(AlertContext)
    const { setAlert } = alertContext
    const [showPopup, setShowPopup] = useState(false)
    const [pendingAuctionId, setPendingAuctionId] = useState(null)

    const checkTermsAndProceed = async ({ auctionId }) => {
        try {
            if (user?.id) {
                const { data } = await axios.get(
                    `${process.env.REACT_APP_BASE_URL}api/getUserTermsForAuction`,
                    {
                        params: {
                            site_id: global.storeDetails.site_id,
                            user_id: user?.id,
                            auction_id: auctionId,
                        },
                    },
                )

                if (data.status === 0) {
                    console.log('')
                    setPendingAuctionId(auctionId)
                    setShowPopup(true)

                    return false
                }
            }

            return true
        } catch (err) {
            console.error('Error checking auction terms', err)
            return false
        }
    }

    const acceptTerms = async () => {
        try {
            const { data } = await axios.post(
                `${process.env.REACT_APP_BASE_URL}api/updateUserTermsForAuction`,
                {
                    site_id: global.storeDetails.site_id,
                    user_id: user?.id,
                    auction_id: pendingAuctionId,
                },
            )

            if (data.success) {
                setShowPopup(false)
                onAccepted?.(pendingAuctionId)
            } else {
                setAlert('Terms and conditions not accepted', 'error')
            }
        } catch (err) {
            console.error('Error accepting auction terms', err)
        }
    }

    return {
        showPopup,
        setShowPopup,
        checkTermsAndProceed,
        acceptTerms,
    }
}
